import { render } from "./OrderSummary.vue?vue&type=template&id=f8db2a2e"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f8db2a2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8db2a2e', script)) {
    api.reload('f8db2a2e', script)
  }
  
  module.hot.accept("./OrderSummary.vue?vue&type=template&id=f8db2a2e", () => {
    api.rerender('f8db2a2e', render)
  })

}

script.__file = "src/components/checkout/modules/OrderSummary.vue"

export default script